import { lazy, useCallback, useMemo } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router';

import OrderFormContainer from '@components/RequisitionCreate/OrderFormContainer/OrderFormContainer';
import { usePatientDetail } from '@hooks';

const RequisitionJSONSchemaForm = lazy(
  () => import('@components/RequisitionCreate/RequisitionJSONSchemaForm/RequisitionJSONSchemaForm'),
);

export const OrderNewReport: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const patientId = useMemo(() => params?.id, [params]);
  const requisitionId = useMemo(() => params?.reqId, [params]);
  const campaignCode = useMemo(() => searchParams.get('campaign'), [searchParams]) ?? undefined;

  const { patientName, loading } = usePatientDetail(patientId);

  const moveToPatientDetail = useCallback(() => {
    navigate(`/patients/${patientId}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId]);

  const breadcrumbs = useMemo(
    () => [
      {
        onClick: moveToPatientDetail,
        children: patientName,
      },
      {
        active: true,
        children: 'Order New Report',
      },
    ],
    [moveToPatientDetail, patientName],
  );

  if (loading) {
    return null;
  }

  return (
    <OrderFormContainer
      cancelReturnsToPatient
      enableSaveAsDraft={false}
      breadcrumbs={breadcrumbs}
      title='Order New Report'
      onCancel={moveToPatientDetail}
    >
      <RequisitionJSONSchemaForm selectedCampaignCode={campaignCode} selectedRequisitionId={requisitionId} />
    </OrderFormContainer>
  );
};
